import Config from '@/config.json'

const configKeys = Object.keys(Config)
const featuresKeys = configKeys.filter(el => el.startsWith('VUE_FEATURE_'))
const featuresSettings = {}

featuresKeys.forEach(featureKey => {
  featuresSettings[featureKey] = Config[featureKey] === true || Config[featureKey] === 'true'
})

export { featuresSettings }

export default {
  data () {
    return {
      featuresSettings
    }
  }
}
